import { Controller } from 'stimulus';

import { navigate } from '../../Shared/path-helpers';
import { isSelectionInteraction } from '../selectionInteraction';

export default class extends Controller {
  onSelectionInteraction(e: KeyboardEvent) {
    if (this.disabled) {
      return;
    }
    if (isSelectionInteraction(e) && (e.target as HTMLElement).nodeName !== 'A') {
      const currentTarget = e.currentTarget as HTMLElement;
      if (currentTarget.dataset.turbolinks === 'false') {
        navigate(currentTarget.dataset.href || '');
      } else {
        window.Turbolinks.visit(currentTarget.dataset.href || '');
      }
    }
  }

  get disabled() {
    return this.data.get('disabled') === 'true';
  }
}
